import React from 'react';
import {useTranslation} from "react-i18next";

const ErrorFormAlertView = (data:any)=>{
    const { t } = useTranslation();
    let errors = data.errors;
    let field = data.field;
    let fieldErrors = [];
    if(typeof errors === 'string'){
        fieldErrors.push({
            message: errors
        });
    }else{
        errors.map((error:any) => {
            if (typeof error === 'string' || error instanceof String){
                fieldErrors.push({
                    message: error
                });
                return;
            }
            let errorField = error.field;
            let code = error.code;
            let message = error.message;

            if (errorField === field) {
                fieldErrors.push({
                    code: code,
                    field: errorField,
                    message: message
                });
            }
        });
    }
    return(
        <React.Fragment>

           {
               fieldErrors.map((item: any) =>
                   <div className="alert alert-danger" key={item.code + "_" + item.message}>
                       {item.code
                           ?
                           // item.field ? t(`constraints.${item.field.toLowerCase()}_${item.code}`) :
                           t("constraints." + item.code)
                           : item.message
                       }
                   </div>
               )
           }
        </React.Fragment>
    )
}

export default ErrorFormAlertView;
